module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 54
// module chunks = 0